module.exports = __webpack_public_path__ + "img/89fa2bd.png";